// extracted by mini-css-extract-plugin
export default {"timerBarContainer":"TimerBar_timerBarContainer__uBCnZ","timerBarBackground":"TimerBar_timerBarBackground__PZEUS","timerBarFill":"TimerBar_timerBarFill__W40yq"};